import axios from "../utils/http/axios";
import { ContactForm } from "../models/contact/Email";
import { ServerName } from "../utils/constants/serverName";
import { WebCase } from "../models";
import { WEBCASE_STATE_COOKIES_UNKNOWN_FOUND_REPORTED } from "../utils/constants/websiteCheck";
import { CookieItem } from "../models/websitecheck";

export const sendContactForm = async (form: ContactForm) => {
  return axios
    .post(`${ServerName}/case`, form)
    .then((result) => Promise.resolve(result))
    .catch((error) => Promise.reject(error));
};

export const reportUnknownCookies = async (
  webCase: WebCase,
  cookie: CookieItem
) => {
  try {
    let currentlyReported = webCase.unknown_cookies_reported || "";
    if (currentlyReported.length > 0) {
      currentlyReported = [currentlyReported, cookie.name].join();
    } else {
      currentlyReported = cookie.name;
    }
    await axios.patch(`${ServerName}/case/${webCase.id}`, {
      id: webCase.id,
      type: "web",
      state: WEBCASE_STATE_COOKIES_UNKNOWN_FOUND_REPORTED,
      unknown_cookies_reported: currentlyReported,
    });
    return Promise.resolve();
  } catch {
    return Promise.reject();
  }
};
